/**
 * Simple inverted index utilities that preserve capitalization, newlines, and markdown formatting
 */
export class InvertedIndexUtil {
    /**
     * Creates an inverted index from text
     * @param text - Input text with markdown and newlines
     * @returns Inverted index mapping words to position arrays
     */
    static generateInvertedIndex(text) {
        if (!text || typeof text !== 'string') {
            return {};
        }
        const index = {};
        const parts = text.split(/( +)/); // Split only on spaces, preserve everything else
        let position = 0;
        for (const part of parts) {
            if (part.trim().length > 0) {
                if (!index[part]) {
                    index[part] = [];
                }
                index[part].push(position);
                position++;
            }
        }
        return index;
    }
    /**
     * Reconstructs text from inverted index preserving original formatting
     * @param index - Inverted index
     * @returns Reconstructed text with preserved formatting
     */
    static createAbstractFromInvertedIndex(index) {
        if (!index || Object.keys(index).length === 0) {
            return '';
        }
        // Find max position
        const maxPosition = Math.max(...Object.values(index).flat(), -1);
        const words = new Array(maxPosition + 1);
        // Fill in words at their original positions
        for (const [word, positions] of Object.entries(index)) {
            for (const position of positions) {
                words[position] = word;
            }
        }
        return words.filter(Boolean).join(' ');
    }
}
//# sourceMappingURL=inverted-index.util.js.map